export const contacts = {
  CALL: 'call',
  TEXT: 'text',
  VIBER: 'viber',
  WHATSAPP: 'whatsApp',
  EMAIL: 'email'
};
